function getPersonalizedTag(role: string, preffix?: string): string {
  return `${preffix || 'recommended-for'}-${role}${
    role === 'all' ? '' : 's'
  }`.toLowerCase();
}

export default getPersonalizedTag;
